<template>
  <div>
    <inside-header title="收益明细" />
    <div v-if="promoter_profit.length === 0 && !loading">
      <a-empty />
    </div>
    <div v-else>
      <div v-for="(item, index) in promoter_profit" :key="index"
        style="padding:20px 20px 20px 15px;border-bottom: 1px solid #eee;">
        <div><span style="color:#333333">收益-支付宝</span></div>
        <div>
          <div>{{ item.nick_name }}-{{ item.action | filterAction }}</div>
          <span>{{ item.create_time | dayFormat }}</span>
          <span>{{ item.create_time | minFormat }}</span>
          <span style="float:right;color: red;position:relative;top:-13px;">+{{ item.profit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'UserReturnsDetailed',
  components: {
    InsideHeader
  },
  filters:
  {
    dayFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      var m = date.getMonth() + 1
      var d = date.getDate()
      return m + '月' + d + '日'
    },
    minFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      var h = date.getHours()
      var m = date.getMinutes()
      return h + ':' + m
    },
    filterAction(val) {
      if (val === 'register') {
        return '注册'
      } else if (val === 'realname') {
        return '实名认证'
      } else if (val === 'apply_teacher') {
        return '成为教员'
      }
    }
  },
  data() {
    return {
      loading: true,
      promoter_profit: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/promote/relevant',
        method: 'get'
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.promoter_profit = data.promoter_profit
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>
